export const authors = {
    easypagego: {
        pretty: 'EasyPageGo',
        role: 'Owner',
        src: 'https://img.daisyui.com/images/stock/photo-1534528741775-53994a69daeb.webp'
    },
}